import React, { useState, useEffect } from "react";
import ContinueReadingSection from "../book/ContinueReadingSection";
import NewCoursesSection from "../courses/NewCoursesSection";
import Slider from "../../component/homeSection/Slider";

function HomeAfterLogin() {
  const [language, setLanguage] = useState("ar");

  useEffect(() => {
    const savedLanguage = sessionStorage.getItem('language');
    if (savedLanguage) {
      setLanguage(savedLanguage);
    }
  }, []);

  return (
    <>
       <Slider/>
       <ContinueReadingSection/>
       <NewCoursesSection/>
    
    </>
  );
}

export default HomeAfterLogin;
